module.exports = __webpack_public_path__ + "static/media/i-think-therefore-i-am.245e0536.txt";